module.exports = __webpack_public_path__ + "static/light-logo-26-05096af8527a0200b22fe6699e0d1e8e.png";